import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const DELETE_CONTENT_SECTION = gql`
  mutation deleteContentSection($sectionContainerId: Int!) {
    contentSection {
      deleteContentSection(sectionContainerId: $sectionContainerId)
    }
  }
`;

const deleteContentSectionRequest = ({
  sectionContainerId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={DELETE_CONTENT_SECTION}>
    {(createSection, { loading, error, data }) => {
      const variables = {
        sectionContainerId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentSection.deleteContentSection);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createSection}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

deleteContentSectionRequest.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  sectionContainerId: PropTypes.number.isRequired,
};

deleteContentSectionRequest.defaultProps = {};

export default deleteContentSectionRequest;
